import React from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { InlineTextButton, Modal } from '../../components';

import css from './SearchPage.module.css';

const FilterModal = props => {
  const intl = useIntl();
  const {
    isOpen,
    onClose,
    onApply,
    onReset,
    onManageDisableScrolling,
    totalItems,
    children,
    viewportSafeLayout = false,
  } = props;

  const viewportSafeModalProps = viewportSafeLayout
    ? {
        scrollLayerClassName: css.searchFilterModalScrollLayer,
        containerClassName: css.searchFilterModalContainer,
        contentClassName: css.searchFilterModalContent,
      }
    : {
        isFilterModal: true,
      };

  return (
    <Modal
      id="SearchPage.filters"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      closeButtonMessage={intl.formatMessage({ id: 'SearchPage.filterModal.close' })}
      modalTitle=<FormattedMessage id="SearchPage.filterModal.title" />
      {...viewportSafeModalProps}
    >
      <div className={css.allFilters}>{children}</div>

      <div className={css.filterFooter}>
        <InlineTextButton type="button" className={css.resetAllFiltersButton} onClick={onReset}>
          <FormattedMessage id="SearchFiltersMobile.resetAll" />
        </InlineTextButton>
        <button type="button" className={css.showResults} onClick={onApply}>
          <FormattedMessage id="SearchPageWithList.totalItems" values={{ totalItems }} />
        </button>
      </div>
    </Modal>
  );
};

export default FilterModal;
